<template>
  <v-app id="inspire">
      <v-overlay :value="loading"></v-overlay>
    <v-card class="ma-4">
      <v-card-title>
        Liste des contrats en cours
        <v-spacer></v-spacer>
        
      </v-card-title>
        <v-card-text class="col-lg-4 col-md-4 col-sm-6 col-xs-12" right>
        <v-spacer></v-spacer>
        <v-text-field 
          v-model="search"
          append-icon="mdi-magnify"
          label="Rechercher"
          single-line
          hide-details
        ></v-text-field>
        </v-card-text>
      <v-data-table
        :headers="headers"
        :items="souscriptions"
        :search="search"
      >
      <template v-slot:item.cancelBtn="{ item }">
        <v-btn @click="cancelSouscription(item)" :loading="loading && item.idCrypt == index">
          Annuler
        </v-btn>
      </template>
      <template v-slot:item.nextBtn="{ item }">
        <v-btn @click="poursuivre(item)" color="warning" :loading="loading && item.idCrypt == index">
          Poursuivre
        </v-btn>
      </template>
      </v-data-table>
    </v-card>
   </v-app>
</template>

<script>
  import {SouscriptionService} from '../../../providers/SouscriptionService.js';
const souscriptionService = new SouscriptionService();
export default {
    name: 'pendingList',
  data() {
    return {
      search: '',
      index:-1,
      loading: false,
      headers: [
        {text: 'Contrat',align: 'start',value: 'souscript_contrat'},
        {text: 'Nom',align: 'start',value: 'souscript_client_nom'},
        { text: 'Prénom', value: 'souscript_client_prenom' },
        { text: '', value: 'cancelBtn', sortable: false, align: 'center'},        
        { text: '', value: 'nextBtn', sortable: false, align: 'center'}
      ],
      souscriptions:[]
    };
  },
  mounted (){
    
    sessionStorage.removeItem('souscription');
    this.getListesouscriptions();
  },
  methods: {
      reloadSouscription: function(){
        this.dialogAddVad = false;
        this.getListesouscriptions();
      },
      getListesouscriptions: function(){
        this.$root.progress = true;
        souscriptionService.getAllPendingByCodevendeur(this.$root.user.codevendeur).then(res => { 
          this.$root.progress = false;
          if(res){
            if (res.err !='error') {
              this.souscriptions = res.params;
                         
            }else{
              this.$dialog.error({
                text: res.err_msg,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
            
            }
          }
        }).catch(error=>{
    
              this.loading = false;
              this.$dialog.notify.error(this.$root.errorMessage, {
                        position: 'bottom-right',
                        timeout: 5000
                      })
            return error;
          })
      },
      deleteItem:async function(souscription){
           await this.$dialog.confirm({
          text: 'Etes vous certain de vouloir annuler cette souscription?',
          type:'warning',
          title: 'Alert',
          actions: {
            false: 'Non',
            true: {
              color: 'red',
              text: 'Oui',
              handle: () => {
                this.cancelSouscription(souscription);
              }
            }
          }
        })
      },
      poursuivre: function(souscription){
        this.$globalService.rechargeSessionSouscription(souscription.souscript_session_data);
        this.$globalService.setSessionSouscription('fromPendingList',true);              
        //redirection vers le dernier workflow
        const step = souscription.souscript_step_last;
        switch (step) {
          case 'MAPPING':
          case 'CONTRAT':
            
            if( souscription.souscript_session_data.offreChoisie.type == 'MOB')
              this.$router.push({name: 'ContactMobile'}); 
            else
              this.$router.push({name: 'Contact'});
            break;
          case 'WEBFLOSIGN':
            this.$router.push({name: 'Signature'});
            break;
          case 'RDV':
            this.$router.push({name: 'RdvCreneaux'});
            // expected output: "Mangoes and papayas are $2.79 a pound."
            break;
        }

      },
      cancelSouscription: function(souscription){
        this.index = souscription.idCrypt;
        this.loading = true;
        souscriptionService.cancelSouscription(souscription.idCrypt).then(res => { 
          this.loading = false;
          this.index = -1;
          if(res){
            if (res.err !='error') {
              this.$dialog.notify.success(res.err_msg, {
                position: 'top-right',
                timeout: 5000
              })
              this.getListesouscriptions();
                         
            }else{
              this.$dialog.error({
                text: res.err_msg,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
            
            }
          }
        }).catch(error=>{
    
              this.loading = false;
              this.$dialog.notify.error(this.$root.errorMessage, {
                        position: 'bottom-right',
                        timeout: 5000
                      })
            return error;
          })
          
      }
  }
};
  
</script>
